import { useQueryClient } from '@tanstack/react-query';
export function useQueryInvalidation(caches: string[]) {
    const queryClient = useQueryClient();
    return () => {
        caches.forEach((cacheKey) => {
            void queryClient.invalidateQueries({
                predicate: ({ queryKey }) => queryKey?.[0] === cacheKey,
            });
        });
    };
}
